import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';

import { DeleteModalDialog } from 'components/shared';

const OptionsDropdownItemDelete = ({
  promptTitle,
  promptDescription,
  deleteAction,
  buttonLabel = 'Delete',
  disabled = false,
  uniqueId: _uniqueId = undefined,
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    // Mirrors OptionsDropdownItem's disabled guard: while disabled (e.g. a
    // delete is already in flight for another row - see isDeleting in
    // LedgersList.react.js), a click must not even open the confirmation
    // dialog, so a rapid double-click can't queue up a second independent
    // delete before the UI's disabled state has visibly updated.
    if (disabled) return;
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MenuItem disabled={disabled} onClick={handleClickOpen}>
        {buttonLabel}
      </MenuItem>
      <DeleteModalDialog
        title={promptTitle}
        message={promptDescription}
        open={open}
        onClose={handleClose}
        onDelete={deleteAction}
      />
    </>
  );
};

OptionsDropdownItemDelete.propTypes = {
  promptTitle: PropTypes.node.isRequired,
  promptDescription: PropTypes.node.isRequired,
  deleteAction: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  disabled: PropTypes.bool,
  uniqueId: PropTypes.any,
};

export default OptionsDropdownItemDelete;
